import { AnyAction } from 'redux';
import { Vorvertrag } from '@ps20-frontend/frontend-models';
import { GlobalActions, UpdateLoadedVorvertraege } from '@ps20-frontend/shop-integration-redux';
import { OperatingStandardVertragsdaten } from '@ps20/bff-models';
import cloneDeep from 'lodash/cloneDeep';
import { DashboardActions } from '../dashboard.actions';
import { updateVertraege } from './fremdVertrag.reducer';

export const vorvertragsUebersichtReducer = function (
  sectionState: Array<Vorvertrag> = null,
  action: AnyAction,
): Array<Vorvertrag> {
  switch (action.type) {
    case GlobalActions.UPDATE_VORVERTRAEGE: {
      const actionPayload: UpdateLoadedVorvertraege = action.payload;
      return actionPayload.standardVorvertraege;
    }
    case DashboardActions.UPDATE_STANDARD_VORVERTRAEGE: {
      const payload: Array<OperatingStandardVertragsdaten> = action.payload;
      const vorvertraege: Array<Vorvertrag> = cloneDeep(sectionState);
      return updateVertraege(payload, vorvertraege) as Array<Vorvertrag>;
    }
    default:
      return sectionState;
  }
};
